export enum SearchParamsEnum {
    ORDER = "orderBy",
    WHERE = "where",
    SELECT = "select",
    LIMIT = "limit",
    OFFSET = "offset",
}

export enum SearchParamsScreenEnum {
    FILTERS = "filters",
    REGISTER = "register",
    EDIT = "edit",
    CLONE = "clone",
    DETAILS = "details",
}
